import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/posicionamiento/loja/PosicionamientoLojaClient.tsx");
